import { render, staticRenderFns } from "./ICopy.vue?vue&type=template&id=5d1db2b0&"
import script from "./ICopy.vue?vue&type=script&lang=ts&"
export * from "./ICopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports